import * as React from "react";
import {SectionWrapper} from "./index";
import {IRootState} from "../../reducers";
import {connect} from "react-redux";

class InventoryformPreviewComponent extends React.Component<any, any> {

    public render() {
        const { values } = this.props.mainForm.mainForm;
        return (
            <SectionWrapper>
                <div className='PrintSectionHeader'>Inventory</div>

                <div className="PrintContainerWrapper commentWrapper">
                    <div className='PrintCommentContainer'>
                        <div className='PrintCommentLabel'>
                            Description of loss:
                        </div>
                        <div className="PrintCommentValue">
                            {values.shipments[0].description}
                        </div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Warehouse name:</div>
                        <div className='PrintItemValue'>{values.shipments[0].warehouseName}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Storage location:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].storageLocation}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Plant no:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].plantNo}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Address:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].address}</div>
                    </div>
                </div>

                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Insurance posting reference:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].insurancePostingReference}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Actual insured values:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].actualInsuredValues}</div>
                    </div>

                </div>
                <div className="PrintContainerWrapper">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Premium:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].premium}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Total claims value supplies:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].totalClaimsValuesSupplies}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper extra-margin">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>
                            Deductible under the policy:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].deductibleUnderThePolicy}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'></div>
                        <div className='PrintItemValue'></div>
                    </div>
                </div>
                <div className="PrintContainerWrapper commentWrapper">
                    <div className='PrintCommentContainer'>
                        <div className='PrintCommentLabel'>
                            PSB - Confirm that for all cases of shortage/loss/damage the records in Vision has been adjusted and the items are moved to the PSB bin (099) in Vision.
                        </div>
                        <div className="PrintCommentValue">

                        </div>
                    </div>
                </div>
                <div className="PrintContainerWrapper extra-margin">
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>
                            <input type='checkbox' name='psbinventory' />
                        </div>
                        <div className='PrintItemValue'></div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>If No Please Comment:</div>
                        <div className='PrintItemValue'>{values.shipments[0].psbcomments}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">

                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'>Recovery value:
                        </div>
                        <div className='PrintItemValue'>{values.shipments[0].recoveryValue}</div>
                    </div>
                    <div className='PrintItemContainer'>
                        <div  className='PrintItemLabel'></div>
                        <div className='PrintItemValue'></div>
                    </div>
                </div>
            </SectionWrapper>

        )
    }
}

// export default QmuformPreviewComponent;
const mapStateToProps = (state: IRootState) => {
    return {
        mainForm: state.form
    };
};

// connect the form wrapper to the state store
export default connect(
    mapStateToProps,
    null
)(InventoryformPreviewComponent)